export enum API_KEY_TYPES {
  BULK_LOAD = 'BulkLoad',
  JAVASCRIPT_SDK = 'JavaScriptSDK',
  MOBILE = 'Mobile',
  STANDARD = 'Standard',
  READ_ONLY = 'ReadOnly',
  SERVER_SIDE = 'ServerSide',
  WEB = 'WebSDK',
}

export enum API_KEY_TYPE_CATEGORIES {
  CLIENT_SIDE = 'Client-side',
  SERVER_SIDE = 'Server-side',
}

export type ApiKeyTypeRaw = {
  label: string; // 'Bulk Load'
  value: API_KEY_TYPES; // 'BulkLoad'
  type: string; // 'Server-side'
  description: string; // Read and write Iterable data from a server-side application. Access all API endpoints, except those intended for exclusive use by Mobile, SDK, and Javascript clients.
};

export type ApiKeyTypeFormatted = ApiKeyTypeRaw & {
  dataTest: string; // 'option-BulkLoad'
  disabled: boolean;
};

export type EditableApiKey = {
  enabled: boolean;
  jwtEnabled: boolean;
  name: string;
  keyType: API_KEY_TYPES;
};

export type ApiKey = {
  createdAt: string; // '2023-01-03T22:41:44.251Z'
  creatorUserId: string; // 'joe.shmoe@iterable.com'
  customEventManageAllowCreationUntil: string | null;
  enabled: boolean;
  jwtRequired: boolean;
  keyHash: string; // '407c0cfb779085ffc82e7faf609fc0819a4a303b3c77878aaad90aa41148f603'
  keyIdentifier: string; // 'bb473361'
  keyType: API_KEY_TYPES; // 'ReadOnly'
  name: string; // 'My Api Key'
  projectId: number; // 1
  updatedAt: string; // '2023-01-03T23:14:59.075Z'
  lastUsedAt: string; // '2023-01-03T23:14:59.075Z'
  __typename: string; // 'ApiKey'
};

export type CreateApiKeyResponse = ApiKey; // current API response, would like to move to { message, data} format

export type EditApiKeyPayload = {
  creatorUserId: string;
  enabled: boolean;
  key: string;
  keyHash: string;
  keyIdentifier: string;
  keyType: API_KEY_TYPES;
  name: string;
  projectId: number;
};

export type FetchApiKeysResponse = {
  message: string;
  data: Record<string, any>;
};
